import {
  IconButton,
  Theme,
  Typography,
  createStyles,
  makeStyles,
} from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import { Close } from '@material-ui/icons';
import React, { FC } from 'react';
import colors from '../../../../../themes/main-colors';
import { Shadow } from '../../../../../constants/shadow';
import { useTranslation } from '../../../../../hooks/useTranslation';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

type Props = {
  open: boolean;
  name: string;
  onClose: () => void;
  onClick: (type: string) => void;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalWrapper: {
      top: '50%',
      left: '50%',
      width: '850px',
      display: 'flex',
      padding: '0px 10px 20px 10px',
      overflow: 'auto',
      position: 'absolute',
      transform: 'translate(-50%, -50%)',
      maxHeight: '77.21vh',
      borderRadius: '5px',
      flexDirection: 'column',
      backgroundColor: '#E6F5FF',
      [theme.breakpoints.down('sm')]: {
        top: '50%',
        width: '90%',
        maxHeight: '100%',
        padding: theme.spacing(3),
      },
    },
    closeButton: {
      position: 'absolute',
      top: 6,
      right: 24,
    },

    outageTypeSection: {
      background: colors.navBarBackground,
      margin: '0rem 1rem',
      boxShadow: Shadow.ONE,
      maxHeight: '100%',
      height: '100%',
      cursor: 'pointer',
      width: '39vw',
      borderRadius: '5px',

      '&:hover': {
        border: `1.5px solid ${colors.sparkBlue}`,
      },
    },

    outageTypeStyling: {
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
    },

    headerContent: {
      paddingLeft: '2rem',
      letterSpacing: '1px',
      paddingRight: '3rem',
    },

    customMarginTop1rem: {
      marginTop: '1rem',
    },

    outageTypeHeader1: {
      marginTop: '1rem',
      letterSpacing: '0px',
    },

    outageTypeContentMargin: {
      marginRight: '1rem',
      marginLeft: '1rem',
      width: '90%',
    },

    modalBody: {},
    kickerText: {
      paddingBottom: theme.spacing(1.875),
      paddingTop: theme.spacing(1.25),
      fontSize: '1.25rem',
      lineHeight: '1.5rem',
      [theme.breakpoints.down('sm')]: {
        fontSize: '1rem',
      },
    },
  }),
);

const OutageType: FC<Props> = ({ open, name, onClose, onClick }) => {
  const classes = useStyles();
  const { t, richT } = useTranslation();

  return (
    <Modal
      open={true}
      onClose={onClose}
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
    >
      <div className={classes.modalWrapper}>
        <div className={classes.headerContent}>
          <Typography style={{ marginTop: '1.5rem' }} variant={'h3'}>
            {t('HELLO')} {`${name},`}
          </Typography>
          <Typography
            variant={'subtitle1'}
            className={classes.outageTypeHeader1}
          >
            {richT('ARE_YOU_EXPERIENCING_DIM_OR_FLICKERING_LIGHTS')}
          </Typography>
        </div>
        <div className={classes.closeButton}>
          <IconButton
            aria-label="close"
            color="inherit"
            onClick={onClose}
            data-testid="close-icon"
          >
            <Close />
          </IconButton>
        </div>
        <div className={classes.customMarginTop1rem}>
          <div className={classes.outageTypeStyling}>
            <div
              className={classes.outageTypeSection}
              onClick={() => {
                onClick('fullOrPartialOutage');
              }}
            >
              <div>
                <div className={classes.outageTypeStyling}>
                  <div>
                    <img
                      style={{
                        maxWidth: '80%',
                        maxHeight: '80%',
                        paddingTop: '10px',
                      }}
                      src={require('../../../../../images/FullOrPartialOutage.svg')}
                      alt="FullOrPartialOutageImage"
                    />
                  </div>
                  <div>
                    <Typography variant={'subtitle1'}>
                      {richT('FULL_OR_PARTIAL_OUTAGE')}
                    </Typography>
                  </div>
                  <div>
                    <ChevronRightIcon />
                  </div>
                </div>
                <Typography
                  variant={'subtitle1'}
                  className={classes.outageTypeContentMargin}
                >
                  {richT('FULL_OR_PARTIAL_OUTAGE_CONTENT')}
                </Typography>
              </div>
            </div>
            <div
              className={classes.outageTypeSection}
              onClick={() => {
                onClick('dimOrFlickering');
              }}
            >
              <div>
                <div className={classes.outageTypeStyling}>
                  <div>
                    <img
                      style={{
                        maxWidth: '80%',
                        maxHeight: '80%',
                        paddingTop: '10px',
                      }}
                      src={require('../../../../../images/DimOrFlickering.svg')}
                      alt="DimOrFlickeringImage"
                    />
                  </div>
                  <div>
                    <Typography variant={'subtitle1'}>
                      {richT('DIM_OR_FLICKERING_LIGHTS')}
                    </Typography>
                  </div>
                  <div>
                    <ChevronRightIcon />
                  </div>
                </div>
                <div>
                  <Typography
                    variant={'subtitle1'}
                    className={classes.outageTypeContentMargin}
                  >
                    {richT('DIM_OR_FLICKERING_LIGHTS_CONTENT')}
                  </Typography>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default OutageType;
